import React, { Component } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
export default class FluencyLetterS extends Component {
  render() {
    var {
      fluecy_letter_s_stop_watch_1,
      noOfWords,
      flu_s_part_1_note,
      fluecy_letter_s_stop_watch_2,
      fluency_ls_score,
      letter_s_no_of_words,
      fluecy_letter_s_stop_watch_2,
      fluency_ls_score,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-10 pt-2">
          <ul
            style={{
              paddingLeft: 20,
              fontSize: 19,
              paddingBottom: 20,
              paddingTop: 30,
            }}
          >
            <h4>PART 1</h4>
            <hr />
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  The person can perform this task either by speaking by giving
                  participant a letter of the alphabet. Then have the
                  participant say as many different words as you can beginning
                  with that letter. But not names of people or places, or
                  numbers.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If speaking, say: “You will have one minute and the letter is
                  S.)
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Not counted at this stage but important to note the amount of
                  words said
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  "I'm going to make sure my team is ready for this question.
                  &#60;Partner name&#62;, Are you ready to take notes?"
                </li>
                <li style={{ listStyle: "circle" }}>
                  ‘I am going to give you a letter of the alphabet and I would
                  like you to say as many different words as you can beginning
                  with that letter, but not names of people or places, or
                  numbers.’
                </li>
                <li style={{ listStyle: "circle" }}>
                  ‘You will have one minute. The letter is S.’
                </li>
              </ul>
            </li>
            <hr />
            <div className="d-flex align-items-center">
              <div style={{ marginLeft: 20 }}>
                <CountdownCircleTimer
                  isPlaying={false}
                  duration={
                    fluecy_letter_s_stop_watch_1 == "60"
                      ? "60"
                      : Number(60 - fluecy_letter_s_stop_watch_1)
                  }
                  colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                  colorsTime={[50, 40, 30, 20]}
                  size={100}
                >
                  {({ remainingTime }) => remainingTime}
                </CountdownCircleTimer>
              </div>
            </div>
            {noOfWords && noOfWords.length != 0 && (
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 30,
                }}
              >
                Spoken word list:
                <table
                  border="1"
                  cellpadding="8"
                  style={{
                    borderCollapse: "collapse",
                    marginTop: 5,
                    width: 200,
                  }}
                >
                  {noOfWords &&
                    noOfWords.map((item, index) => (
                      <tr key={index}>
                        <td>{item.word}</td>
                      </tr>
                    ))}
                </table>
              </div>
            )}
            <div style={{ maxWidth: 500, marginTop: 24 }}>
              <label className="margin-left">Note:</label>
              <textarea
                name="flu_s_part_1_note"
                value={flu_s_part_1_note}
                className="ecas-textarea-field margin-left"
                rows={6}
                cols={10}
              />
            </div>
            <hr />
            <h4>PART 2</h4>
            <hr />
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Next the person copies/repeats these words.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  “Read aloud these words as fast as possible. Before you do
                  this, check that you can read them. I will time you. Ready?
                  Begin.”
                </li>
              </ul>
              <div className="d-flex align-items-center">
                <div style={{ marginLeft: 20 }}>
                  <CountdownCircleTimer
                    isPlaying={false}
                    duration={fluecy_letter_s_stop_watch_2}
                    colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                    colorsTime={[50, 40, 30, 20]}
                    size={100}
                    rotation="counterclockwise"
                    isSmoothColorTransition={true}
                  >
                    {({ remainingTime }) => remainingTime}
                  </CountdownCircleTimer>
                </div>
              </div>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  All answers provided are recorded however the following rules
                  apply for scoring items as correct. Words must be varied for
                  example: sugar, salt, slipper, snow, scream, shoot, scale,
                  scissors….
                </li>
                <li style={{ listStyle: "circle" }}>
                  Do not include repetitions, nonsense words (i.e. cannot be
                  found in an English dictionary), or proper names in scoring
                  items correct. Repetitions where a second meaning is provided
                  (e.g. ‘school - the educational institution’ or ‘school -
                  collective name of fish’) are scored as independent items.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Likewise, when items are spoken and a different
                  spelling/meaning is indicated (e.g. slow and sloe) items are
                  scored as independently correct. Where a meaning change is
                  indicated (e.g. savour and savoury) items are scored as
                  independently correct. Plural words will be accepted, only if
                  they have not already been provided in singular form (e.g.
                  slipper, slippers = score 1).
                </li>
                <li style={{ listStyle: "circle" }}>
                  Perseverations of words such as sit, sat, sitting… where
                  meaning is not changed, are not accepted as correct (e.g. sit,
                  sat, sitting = score 1, take, took = score 1).
                </li>
                <li style={{ listStyle: "circle" }}>
                  In order to account for differences in motor speed and
                  speaking time variations, a Verbal Fluency Index (VFI) is
                  calculated using the equation below.
                </li>
              </ul>
            </li>
          </ul>
          <div className="row">
            <div className="light-grey border border-dark col-lg-7 fs-19 p-3">
              <b>
                <p className="text-center">
                  Verbal Fluency Index (Vfi) calculation:
                </p>
              </b>
              <br />
              <p>
                Spoken VFI:
                <br />
                <p className="text-center">
                  Vfi = 60seconds – no. of seconds to read aloud words
                  <div
                    style={{
                      width: "87%",
                      height: 1,
                      background: "#000",
                      marginLeft: 55,
                    }}
                  ></div>
                  No. of correct words generated
                  <br />
                </p>
              </p>
            </div>
            <div className="col-lg-5 px-0">
              <table
                style={{
                  padding: "22px 25px",
                  borderBottom: "none !important",
                }}
                className="table-black w-100 border border-dark text-center"
              >
                <tbody>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #000",
                      }}
                    >
                      SPOKEN VFI
                    </th>
                    <th
                      style={{
                        border: "1px solid #000",
                      }}
                      className="light-grey"
                    >
                      Score
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <i className="fas fa-greater-than-equal"></i> 12.00
                    </td>

                    <td className="light-grey">0</td>
                  </tr>
                  <tr>
                    <td>
                      10.00 to <i className="pl-1 fas fa-less-than"></i> 12.00
                    </td>

                    <td className="light-grey">2</td>
                  </tr>
                  <tr>
                    <td>
                      8.00 to <i className="pl-1 fas fa-less-than"></i> 10.00
                    </td>

                    <td className="light-grey">4</td>
                  </tr>
                  <tr>
                    <td>
                      6.00 to <i className="pl-1 fas fa-less-than"></i> 8.00
                    </td>

                    <td className="light-grey">6</td>
                  </tr>
                  <tr>
                    <td>
                      4.00 to <i className="pl-1 fas fa-less-than"></i> 6.00
                    </td>

                    <td className="light-grey">8</td>
                  </tr>
                  <tr>
                    <td>
                      2.00 to <i className="pl-1 fas fa-less-than"></i> 4.00
                    </td>

                    <td className="light-grey">10</td>
                  </tr>
                  <tr>
                    <td>
                      <i className="pl-1 fas fa-less-than"></i> 2.00
                    </td>

                    <td className="light-grey">12</td>
                  </tr>
                </tbody>
              </table>
              <div style={{ padding: "22px 25px" }}>
                <span className="fs-19">Score (0 - 12) </span>
                <input
                  name="fluency_ls_score"
                  onChange={this.handleChange}
                  type="number"
                  className="ecas-input-field"
                  placeholder="Score"
                  value={fluency_ls_score}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2 pt-2" style={{ borderLeft: "1px solid #000" }}>
          <br />
          <p className="fs-19">No. of correct words =</p>
          <input
            type="number"
            name="letter_s_no_of_words"
            className="form-control pl-3"
            style={{ height: 50 }}
            onChange={this.handleChangeFluencyLs}
            value={letter_s_no_of_words}
          />
          <br />
          <p className="fs-19">
            Time to copy/ read aloud ={" "}
            <input
              type="number"
              style={{ height: 50 }}
              className="form-control pl-3"
              name="letter_s_time_to_read"
              value={Number(fluecy_letter_s_stop_watch_2)}
            />
          </p>
          <br />
          <br />
          <br />
          <span className="fs-19">Score (0 - 12) </span>
          <input
            name="fluency_ls_score"
            onChange={this.handleChange}
            type="number"
            className="ecas-input-field"
            placeholder="Score"
            value={fluency_ls_score}
          />
        </div>
      </div>
    );
  }
}
